'use client'

import Link from '@/components/navigation/LoadingLink'
import { usePathname } from 'next/navigation'

function shouldHideEventCta(pathname: string) {
  return (
    pathname === '/event-erstellen' ||
    pathname === '/event-erstellen/bestaetigung' ||
    pathname === '/event-bearbeiten' ||
    pathname.startsWith('/event-bearbeiten/')
  )
}

export function EventCta() {
  const pathname = usePathname()
  if (shouldHideEventCta(pathname)) return null

  return (
    <section className="bg-signal text-white border-b border-ink group cursor-pointer">
      <Link
        href="/event-erstellen"
        className="block p-8 lg:p-16 text-center hover:bg-ink hover:text-signal transition-colors"
      >
        <h2 className="text-4xl lg:text-7xl font-black uppercase leading-none mb-4">
          Dein Event
          <br />
          fehlt?
        </h2>
        <p className="font-mono text-sm lg:text-lg border border-current inline-block px-4 py-2 mt-4 uppercase font-bold">
          Jetzt eintragen &#8594;
        </p>
      </Link>
    </section>
  )
}
